// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pdf-renderer-exam-review[data-v-6820639b],\n#pdf-renderer-temp-exam-review[data-v-6820639b] {\n  line-height: 1.2;\n  z-index: 99999;\n  min-width: 749px;\n  max-width: 750px;\n  overflow-wrap: break-word;\n}\n#pdf-renderer-exam-review .progress-line[data-v-6820639b],\n#pdf-renderer-temp-exam-review .progress-line[data-v-6820639b] {\n  height: 0.25rem;\n  border-radius: 8px;\n}", ""]);
// Exports
module.exports = exports;
